module.exports = __webpack_public_path__ + "officialStatic/img/productB39.eb29137.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/productB39.png
// module id = 3i0n
// module chunks = 0